import { render } from "./Trending.vue?vue&type=template&id=d3d1e676&scoped=true"
import script from "./Trending.vue?vue&type=script&lang=js"
export * from "./Trending.vue?vue&type=script&lang=js"

import "./Trending.vue?vue&type=style&index=0&id=d3d1e676&lang=scss&scoped=true"
import "./Trending.vue?vue&type=style&index=1&id=d3d1e676&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3d1e676"]])

export default __exports__